<section [ngStyle]="outerCss" class="no-ripple">
  <div hlmAccordion type="multiple" #accordionContainer [class]="accordionContainerClasses">
    @for (accordionConfig of accordionConfigs; track accordionConfig; let index = $index) {
      <div
        hlmAccordionItem
        role="heading"
        aria-level="1"
        [isOpened]="openStates[index]"
        [class]="'accordion-item-' + dataIn.uniqueId + '-' + index"
        [attr.data-layout-parent-id]="dataIn.uniqueId"
        [attr.data-layout-index]="index"
      >
        <div
          hlmAccordionTrigger
          role="button"
          [class]="'accordion-trigger accordion-trigger-' + dataIn.uniqueId"
          [ngStyle]="getItemHeaderStyle(index)"
        >
          <span class="accordion-label" [innerHTML]="renderedTitles?.[index] || '' | safeHtml"></span>
          @if (collapsedIcon) {
            <mat-icon [svgIcon]="collapsedIcon" class="accordion-icon"></mat-icon>
          } @else {
            <mat-icon [svgIcon]="'chevron-down'" class="accordion-icon"></mat-icon>
          }
        </div>
        <hlm-accordion-content>
          <section class="accordion-content" [ngStyle]="contentNgStyle">
            @for (component of injectorArray(index); track component) {
              <div [class]="getWidgetClasses(component.widget)">
                <ng-container
                  *ngComponentOutlet="component.component; injector: component.injector"
                ></ng-container>
              </div>
            }
          </section>
        </hlm-accordion-content>
      </div>
    }
  </div>
</section>
